import { getAllCompaniesService, getDeviceIDnByCompanyIDService, getEventReportByCompanyIDService, getEventReportByDeviceIDService, getFloorPlanByCompanyIDService } from "../../services/developer";
import { getEventMessagesService } from "../../services/event";
import { apiError, getAllCompaniesSuccess, getConnectionLogByDeviceIDSuccess, getDeviceIDByCompanyIDSuccess, getEventMessageSuccess, getEventsReportSuccess, getFloorPlansByCompanyIDSuccess } from "./reducer";

export const getEventMessages = (eventID) => async (dispatch) => {
  try {    
    var result = await getEventMessagesService(eventID);
    dispatch(getEventMessageSuccess({eventID: eventID, result: result.data}));
  } catch (error) {
    console.log(error)
    dispatch(apiError(error));
  }
};

export const getAllCompanies = () => async (dispatch) => {
  try {    
    var data = await getAllCompaniesService();   
    dispatch(getAllCompaniesSuccess(data)); 
  } catch (error) {
    console.log(error)
    dispatch(apiError(error));
  } 
}

export const getFloorPlanByCompanyID = (companyID) => async (dispatch) => {
  console.log("Thunk - getFloorPlanByCompanyID - companyID:", companyID);
  try {    
    var data = await getFloorPlanByCompanyIDService(companyID);   
    dispatch(getFloorPlansByCompanyIDSuccess(data));
  } catch (error) {
    console.log(error)
    dispatch(apiError(error));
  } 
}

export const getEventReportByCompanyID = (companyID, selectedMultiFloorPlan, selectedMultiMonitorType, selectedMultiMonitorStatus, selectedMultiEventHandling, dateRange, pageNumber, pageSize) => async (dispatch) => {
  console.log("Thunk - getEventReportByCompanyID - companyID:", companyID);
  try {    
    var data = await getEventReportByCompanyIDService(companyID, selectedMultiFloorPlan, selectedMultiMonitorType, selectedMultiMonitorStatus, selectedMultiEventHandling, dateRange, pageNumber, pageSize);   
    dispatch(getEventsReportSuccess(data));
  } catch (error) {
    console.log(error)
    dispatch(apiError(error));
  } 
}

export const getConnectionLogByDeviceID = (deviceID, dateRange, pageNumber, pageSize) => async (dispatch) => {
  console.log("Thunk - getConnectionLogByDeviceID - deviceID:", deviceID);
  try {    
    var data = await getEventReportByDeviceIDService(deviceID, dateRange, pageNumber, pageSize);   
    dispatch(getConnectionLogByDeviceIDSuccess(data));
  } catch (error) {
    console.log(error)
    dispatch(apiError(error));
  } 
}

export const getDeviceIDByCompanyID = (companyID) => async (dispatch) => {
  console.log("Thunk - getDeviceIDByCompanyID - companyID:", companyID);
  try {    
    var data = await getDeviceIDnByCompanyIDService(companyID);   
    dispatch(getDeviceIDByCompanyIDSuccess({companyID: companyID, data: data.data}));
  } catch (error) {
    console.log(error)
    dispatch(apiError(error));
  } 
}